import * as React from 'react'

export const VehicleUsageIcon = ({
  className,
  fill = 'url(#paint0_linear_1228_10013)',
  percent = 100,
}: {
  className?: string
  fill?: string
  percent?: number
}) => {
  const totalHeight = 66.125
  const fillHeight = (totalHeight * percent) / 100
  const fillY = 62.25 - fillHeight 

  return (
    <svg
      width="75"
      height="60"
      viewBox="0 0 75 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_1228_10013"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="75"
        height="60"
      >
        <path
          d="M5.57812 0.5H42.7656C45.7871 0.5 48.3438 3.05664 48.3438 6.07812V11.6562H54.1543C56.1299 11.6562 58.1055 12.4697 59.5 13.8643L68.4482 22.8125C69.8428 24.207 70.6562 26.1826 70.6562 28.1582V41.4062C72.6318 41.4062 74.375 43.1494 74.375 45.125C74.375 47.2168 72.6318 48.8438 70.6562 48.8438H66.9375C66.9375 55.0029 61.9404 60 55.7812 60C49.6221 60 44.625 55.0029 44.625 48.8438H29.75C29.75 55.0029 24.7529 60 18.5938 60C12.4346 60 7.4375 55.0029 7.4375 48.8438H5.57812C2.44043 48.8438 0 46.4033 0 43.2656V6.07812C0 3.05664 2.44043 0.5 5.57812 0.5ZM48.3438 19.0938V30.25H63.2188V28.1582L54.1543 19.0938H48.3438ZM13.0156 48.8438C13.0156 50.9355 14.0615 52.6787 15.8047 53.7246C17.4316 54.7705 19.6396 54.7705 21.3828 53.7246C23.0098 52.6787 24.1719 50.9355 24.1719 48.8438C24.1719 46.8682 23.0098 45.125 21.3828 44.0791C19.6396 43.0332 17.4316 43.0332 15.8047 44.0791C14.0615 45.125 13.0156 46.8682 13.0156 48.8438ZM55.7812 43.2656C53.6895 43.2656 51.9463 44.4277 50.9004 46.0547C49.8545 47.7979 49.8545 50.0059 50.9004 51.6328C51.9463 53.376 53.6895 54.4219 55.7812 54.4219C57.7568 54.4219 59.5 53.376 60.5459 51.6328C61.5918 50.0059 61.5918 47.7979 60.5459 46.0547C59.5 44.4277 57.7568 43.2656 55.7812 43.2656Z"
          fill="#D1E2F6"
        />
      </mask>
      <g mask="url(#mask0_1228_10013)">
        <rect x="-1.75" y="-3.875" width="84" height="66.125" fill="#D1E2F6" />
        <rect x="-1.75" y={fillY} width="84" height={fillHeight} fill={fill} />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1228_10013"
          x1="-1.75"
          y1="39"
          x2="82.2485"
          y2="39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C57FF" />
          <stop offset="1" stopColor="#48A1FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
